// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum NOTIFICATION_TYPE {
    annotationComment = 'annotation-comment',
    bookInviteClaimed = 'book-invite-claimed',
    webBookAccessRevokedChargeback = 'web-book-access-revoked-chargeback',
    webBookAccessRevokedRefund = 'web-book-access-revoked-refund',
}
